import { createSlice } from "@reduxjs/toolkit";
import { getTasksInLocalStorage } from "./tasksLocalStorage";

const tasksSlice = createSlice({
  name: "tasks",
  initialState: {
    tasks: getTasksInLocalStorage(),
    hideDone: false,
    loading: false,
  },

  reducers: {
    addTask: ({ tasks }, { payload }) => {
      tasks.push(payload);
    },

    // "Deep Destructuring" (Głęboka destrukturyzacja)
    //  addTask: ({ tasks }, { payload: task }) => {
    //   tasks.push(task);
    // },

    toggleHideDone: (state) => {
      state.hideDone = !state.hideDone;
    },

    toggleTaskDone: ({ tasks }, { payload }) => {
      const index = tasks.findIndex((task) => task.id === payload);
      tasks[index].done = !tasks[index].done;
    },

    // "Deep Destructuring" (Głęboka destrukturyzacja)
    // toggleTaskDone: ({ tasks }, { payload: taskId }) => {
    //   const index = tasks.findIndex(({id}) => id === taskId);
    //   tasks[index].done = !tasks[index].done;
    // },

    setAllDone: (state) => {
      state.tasks.forEach((task) => {
        task.done = true;
      });
    },

    // z pętlą for...of
    // setAllDone: ({ tasks }) => {
    //   for (const task of tasks) {
    //     task.done = true;
    //   }
    // },

    removeTask: (state, action) => {
      state.tasks = state.tasks.filter((task) => task.id !== action.payload);
    },

    removeAllTasks: (state) => {
      state.tasks = [];
    },

    // Głęboka destrukturyzacja
    // removeTask: ({ tasks }, { payload: taskId }) => {
    //   const index = tasks.findIndex(({ id }) => id === taskId);
    //   tasks.splice(index, 1);
    // },

    // Głęboka destrukturyzacja z zabezpieczeniem przed "off-by-one"
    // removeTask: ({ tasks }, { payload: taskId }) => {
    //   const index = tasks.findIndex(({ id }) => id === taskId);
    //   if (index !== -1) {
    //     tasks.splice(index, 1);
    //   }
    // },

    fetchExampleTasks: (state) => {
      state.loading = true;
    },

    setTasks: (state, { payload: tasks }) => {
      state.tasks = tasks;
      state.loading = false;
    },
  },
});

export const {
  addTask,
  toggleHideDone,
  toggleTaskDone,
  setAllDone,
  removeTask,
  fetchExampleTasks,
  setTasks,
  removeAllTasks,
} = tasksSlice.actions;

export const selectTasksState = (state) => state.tasks;
/* cały obiekt stanu "tasks": { tasks: [], hideDone: false } */

export const selectTasks = (state) => selectTasksState(state).tasks;
/* tylko tablica zadań: [] */

export const selectHideDone = (state) => selectTasksState(state).hideDone;
/* tylko flaga hideDone: false */

export const selectAreTasksEmpty = (state) => selectTasks(state).length === 0;
/* sprawdza, czy są jakieś zadania (długość tablicy (selectTasks)) */

export const selectIsEveryTaskDone = (state) =>
  selectTasks(state).every(({ done }) => done);
/* wywołuje .every() na [] (selectTasks) - sprawdza, czy wszystkie są ukończone */

export const selectLoading = (state) => selectTasksState(state).loading;

export const getTaskById = (state, taskId) =>
  selectTasks(state).find(({ id }) => id === taskId);

export const selectTasksByQuery = (state, query) => {
  const tasks = selectTasks(state);

  if (!query || query.trim() === "") {
    return tasks;
  }

  return tasks.filter(({ content }) =>
    content.toUpperCase().includes(query.trim().toUpperCase()),
  );
};

export default tasksSlice.reducer;
